import React, { useCallback } from 'react';

import T from '@prisjakt/ui-translate';

import * as S from './styles';

type OwnProps = {
  setRating: (rating: number) => void;
};

type Props = OwnProps;

const UserSentimentRate = ({ setRating }: Props) => {
  const voteAngry = useCallback(() => {
    setRating(1);
  }, [setRating]);

  const voteDissatisfied = useCallback(() => {
    setRating(2);
  }, [setRating]);

  const voteNeutral = useCallback(() => {
    setRating(3);
  }, [setRating]);

  const voteSmiling = useCallback(() => {
    setRating(4);
  }, [setRating]);

  const voteLaughing = useCallback(() => {
    setRating(5);
  }, [setRating]);

  return (
    <S.UserSentimentForm data-test="UserSentimentRating">
      <S.Question>
        <T domain="user-sentiment">user-sentiment.rating-question</T>
      </S.Question>

      <S.Rating>
        <S.RateButton onClick={voteAngry}>
          <S.Angry />
        </S.RateButton>

        <S.RateButton onClick={voteDissatisfied}>
          <S.Dissatisfied />
        </S.RateButton>

        <S.RateButton onClick={voteNeutral}>
          <S.Neutral />
        </S.RateButton>

        <S.RateButton onClick={voteSmiling}>
          <S.Smiling />
        </S.RateButton>

        <S.RateButton onClick={voteLaughing}>
          <S.Laughing />
        </S.RateButton>
      </S.Rating>
    </S.UserSentimentForm>
  );
};

export default UserSentimentRate;
